module.exports = __webpack_public_path__ + "img/imagen1.90d50417.png";